import { createApi } from '@reduxjs/toolkit/query/react';
import { type TCurrencyCapability } from '../types/CurrencyTypes';
import { baseQuery, getBaseQueryWithReauth } from '../baseQueryAuth';

export const CurrencyApi = createApi({
  reducerPath: 'CurrencyApi',
  tagTypes: ['Currency'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    getCurrencies: build.query<TCurrencyCapability[], 'order' | 'withdrawal'>({
      query: (operation) => ({
        url: '/currencies/',
        method: 'GET',
        params: { operation },
      }),
    }),
    getCheckActivePayments: build.query({
      query: () => ({
        url: '/requisite/check_active_payments_type/',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetCurrenciesQuery, useGetCheckActivePaymentsQuery } = CurrencyApi;
